import getQueryParam from './getQueryParam';

interface QueryParamObject {
  [key: string]: string | null;
}

const getQueryParams = (...queryParams: string[]): QueryParamObject => {
  const queryParamObject: QueryParamObject = {};
  for (const queryParam of queryParams) {
    if (typeof queryParam !== 'string') {
      continue;
    }
    queryParamObject[queryParam] = getQueryParam(queryParam);
  }
  return queryParamObject;
};

export default getQueryParams;
